export default "__VITE_ASSET__CdHLDiz7__"